/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Story_HintInputs */

const vi_shop_group_story_hint = /** @type {(inputs: Shop_Group_Story_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một mục Câu chuyện ở Bán lẻ → Trang & câu chuyện. Để trống nếu nhóm không có câu chuyện.`)
};

/**

* @param {Shop_Group_Story_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_hint = /** @type {((inputs?: Shop_Group_Story_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_hint(inputs)
});